import React, { Component } from 'react';
import { Label, Icon } from 'semantic-ui-react';

export default class FloatingFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            parentModel: null
        };
    }
    // when does this get called? how to test this?
    onParentModelChanged(parentModel) {
        this.setState({
            parentModel: parentModel
        });
    }
    remove(item) {
        this.props.onFloatingFilterChanged({
            model: this.state.parentModel.filter(it => it !== item)
        });
    }
    render() {
        if (!this.state.parentModel) return null;
        if (this.state.parentModel.length > 3) {
            return (
                <Label as="a" size="mini" color="blue">
                    {this.state.parentModel.length} items selected
                </Label>
            );
        }
        // as the backing filter is a set filter what we're doing here is rendering the list in the set
        // and when the [x] removing the selected item, thereby effectively hiding it
        let options = this.state.parentModel.map((item, i) => {
            return (
                <Label as="a" size="mini" color="blue" key={i}>
                    {item}
                    <Icon name="delete" onClick={() => this.remove(item)} />
                </Label>
            );
        });

        return <div>{options}</div>;
    }
}



// WEBPACK FOOTER //
// ./components/atoms/FloatingFilter.jsx